import { render } from "./sign.in.desk.vue?vue&type=template&id=815c3332"
import script from "./sign.in.desk.vue?vue&type=script&lang=js"
export * from "./sign.in.desk.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__